export const isRoughly16by9 = (width: number, height: number) => {
  if (width <= 0 || height <= 0) {
    return false;
  }

  return Math.abs(16 / 9 - width / height) <= 0.1;
};
